module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cfu2v"))).then(() => parcelRequire('hEqeo'));